import axios from "axios";

import { userLogout } from "./user";
import { getAuthHeader } from "../headers";

// ===================================
//  MASS EMAIL OPTIONS 
// ===================================
export const optionsIsLoading = () => {
	return {
		type: "MASS_EMAIL_OPTIONS_IS_LOADING"
	};
};

export const optionsHasError = err => {
	return {
		type: "MASS_EMAIL_OPTIONS_HAS_ERROR",
		error: err
	};
};

export const optionsSuccess = data => {
	return {
		type: "MASS_EMAIL_OPTIONS_SUCCESS",
		data
	};
};

// Get options from backend
export function getMassEmailOptions(){
    return (dispatch, getState) => {
        dispatch(optionsIsLoading());

        return axios
            .get(process.env.REACT_APP_API_URL + "reviews-email/mass-options", {
                headers: getAuthHeader(getState().user, true)
            })
            .then(response => {
                if (response.data.status === 403) {
					dispatch(userLogout("reviewer"));
					return Promise.resolve(response);
				} else if (response.data.status && response.data.status !== 200) {
					dispatch(optionsHasError(response.data.errors));
					return Promise.resolve(response);
				} else {
					dispatch(optionsSuccess(response.data));
					return Promise.resolve(response);
				}
            })
            .catch(err => {
				dispatch(optionsHasError({ general: err }));
			});
    };
}

// Submit options from backend
export function submitMassEmailOptions(data) {
	return (dispatch, getState) => {
		dispatch(optionsIsLoading());

		return axios
			.post(process.env.REACT_APP_API_URL + "reviews-email/mass-options", data, {
				headers: getAuthHeader(getState().user, true)
			})
			.then(response => {
				if (response.data.status === 403) {
					dispatch(userLogout("admin"));
				} else if (response.data.status !== 200) {
					dispatch(optionsHasError(response.data.errors));
					return Promise.resolve(response);
				}

				dispatch(optionsSuccess(response.data));
				return Promise.resolve(response);
			})
			.catch(err => {
				dispatch(optionsHasError({ general: err }));
			});
	};
}


// ===================================
//  MASS EMAIL SUBMISSIONS 
// =================================== 
export const submissionIsLoading = () => {
	return {
		type: "MASS_EMAIL_SUBMISSION_IS_LOADING"
	};
};

export const submissionHasError = err => {
	return {
		type: "MASS_EMAIL_SUBMISSION_HAS_ERROR",
		error: err
	};
};

export const submissionSuccess = data => {
	return {
		type: "MASS_EMAIL_SUBMISSION_SUCCESS",
		data
	};
};

// Call backend to do the mass email!
export function performMassEmailSubmission(data) {
	return (dispatch, getState) => {
		dispatch(submissionIsLoading());

		return axios
			.post(process.env.REACT_APP_API_URL + "reviews-email/send-email", data, {
				headers: getAuthHeader(getState().user, true)
			})
			.then(response => {
				if (response.data.status === 403) {
					dispatch(userLogout("admin"));
				} else if (response.data.status !== 200) {
					dispatch(submissionHasError(response.data.errors));
					return Promise.resolve(response);
				}

				dispatch(submissionSuccess(response.data.message));
				return Promise.resolve(response);
			})
			.catch(err => {
				dispatch(submissionHasError({ general: err }));
			});
	};
}

// ===================================
//  AUTOMATIC EMAIL NOTICES OPTIONS
// =================================== 
export const noticeOptionsIsLoading = () => {
	return {
		type: "NOTICE_OPTIONS_IS_LOADING"
	};
};

export const noticeOptionsHasError = err => {
	return {
		type: "NOTICE_OPTIONS_HAS_ERROR",
		error: err
	};
};

export const noticeOptionsSuccess = data => {
	return {
		type: "NOTICE_OPTIONS_SUCCESS",
		data
	};
};

// Get notice options from database
export function getNoticeOptions(){
    return (dispatch, getState) => {
        dispatch(noticeOptionsIsLoading());

        return axios
            .get(process.env.REACT_APP_API_URL + "reviews-email/notice-options", {
                headers: getAuthHeader(getState().user, true)
            })
            .then(response => {
                if (response.data.status === 403) {
					dispatch(userLogout("reviewer"));
					return Promise.resolve(response);
				} else if (response.data.status && response.data.status !== 200) {
					dispatch(noticeOptionsHasError(response.data.errors));
					return Promise.resolve(response);
				} else {
					dispatch(noticeOptionsSuccess(response.data));
					return Promise.resolve(response);
				}
            })
            .catch(err => {
				dispatch(noticeOptionsHasError({ general: err }));
			});
    };
}

// Save notice options
export function submitNoticeOptions(data) {
	return (dispatch, getState) => {
		dispatch(noticeOptionsIsLoading());

		return axios
			.post(process.env.REACT_APP_API_URL + "reviews-email/notice-options", data, {
				headers: getAuthHeader(getState().user, true)
			})
			.then(response => {
				if (response.data.status === 403) {
					dispatch(userLogout("admin"));
				} else if (response.data.status !== 200) {
					dispatch(noticeOptionsHasError(response.data.errors));
					return Promise.resolve(response);
				}

				dispatch(noticeOptionsSuccess(response.data));
				return Promise.resolve(response);
			})
			.catch(err => {
				dispatch(noticeOptionsHasError({ general: err }));
			});
	};
}


// WEBPACK FOOTER //
// ./src/store/actions/reviewsEmail.js